<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInDown pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">MONITORING DAN EVALUASI</span>
                <span v-else>MONITORING AND EVALUATION</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Monitoring dan evaluasi</span>
                    <span v-else>Monitoring and evaluation</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <!-- Contact Start -->
    <div class="container-fluid blog py-2">
        <div class="container py-2">
            <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
                style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
                <div class="sub-style">
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-if="(bahasa === null) || (bahasa == 'ina')">
                        REKAPITULASI MONITORING KEGIATAN
                    </h1>
                    <h1 class="sub-title px-3 mb-0 labelpmis" v-else>
                        RECAPITULATION OF MONITORING ACTIVITIES
                    </h1>
                </div>
                <p class="mb-0" v-if="(bahasa === null) || (bahasa == 'ina')">
                    Tanggal Integrasi Data (PMIS, LMS & E-mon): {{ G_formatDate(tanggalsinkron) }}
                    <br>Tanggal Data Monev PMC: {{ G_formatDateNonWIB(tanggaldatamonev) }}
                </p>
                <p class="mb-0" v-else>
                    Data Integration Date (PMIS, LMS & E-mon): {{ G_formatDateEng(tanggalsinkron) }}
                    <br>PMC Monev Data Date: {{ G_formatDateNonWIBEng(tanggaldatamonev) }}
                </p>
            </div>
            <div class="row g-4 justify-content-center">
                <div class="row">
                    <div class="col-sm-12 wow fadeInDown">
                        <div class="card cardputih collapsed-card">
                            <div class="card-header border-transparent" data-card-widget="collapse"
                                style="cursor: pointer;">
                                <label>Filter Kolom</label>
                                <div class="card-tools">
                                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                        <i class="fas fa-plus"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="card-body px-3">
                                <div class="row">
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxStatusKegiatan"
                                                value="optionStatusKegiatan"
                                                @click="showColumnStatusKegiatan = !showColumnStatusKegiatan">
                                            <label for="customCheckboxStatusKegiatan" class="custom-control-label">
                                                Status Kegiatan</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxOuput" value="optionOuput"
                                                @click="showColumnOuput = !showColumnOuput">
                                            <label for="customCheckboxOuput" class="custom-control-label">
                                                Ouput</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxPHOFHO" value="optionPHOFHO"
                                                @click="showColumnPHOFHO = !showColumnPHOFHO">
                                            <label for="customCheckboxPHOFHO" class="custom-control-label">
                                                PHP / FHO</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxPenyedia" value="optionPenyedia"
                                                @click="showColumnPenyedia = !showColumnPenyedia">
                                            <label for="customCheckboxPenyedia" class="custom-control-label">
                                                Penyedia</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxMulai" value="optionMulai"
                                                @click="showColumnMulai = !showColumnMulai">
                                            <label for="customCheckboxMulai" class="custom-control-label">
                                                Mulai</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxSelesai" value="optionSelesai"
                                                @click="showColumnSelesai = !showColumnSelesai">
                                            <label for="customCheckboxSelesai" class="custom-control-label">
                                                Selesai</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxDurasi" value="optionDurasi"
                                                @click="showColumnDurasi = !showColumnDurasi">
                                            <label for="customCheckboxDurasi" class="custom-control-label">
                                                Durasi</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxKontrak" value="optionKontrak"
                                                @click="showColumnKontrak = !showColumnKontrak">
                                            <label for="customCheckboxKontrak" class="custom-control-label">
                                                No Kontrak</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxAdendum" value="optionAdendum"
                                                @click="showColumnAdendum = !showColumnAdendum">
                                            <label for="customCheckboxAdendum" class="custom-control-label">
                                                Adendum</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxBerjalan" value="optionBerjalan"
                                                @click="showColumnBerjalan = !showColumnBerjalan">
                                            <label for="customCheckboxBerjalan" class="custom-control-label">
                                                Durasi Berjalan</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxTersisa" value="optionTersisa"
                                                @click="showColumnTersisa = !showColumnTersisa">
                                            <label for="customCheckboxTersisa" class="custom-control-label">
                                                Durasi Tersisa</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxOWP" value="optionOWP"
                                                @click="showColumnOWP = !showColumnOWP">
                                            <label for="customCheckboxOWP" class="custom-control-label">
                                                OWP</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxTotalAWP" value="optionTotalAWP"
                                                @click="showColumnTotalAWP = !showColumnTotalAWP">
                                            <label for="customCheckboxTotalAWP" class="custom-control-label">
                                                Total AWP</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxAWP" value="optionAWP"
                                                @click="showColumnAWP = !showColumnAWP">
                                            <label for="customCheckboxAWP" class="custom-control-label">
                                                AWP</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxTotalDIPA" value="optionTotalDIPA"
                                                @click="showColumnTotalDIPA = !showColumnTotalDIPA">
                                            <label for="customCheckboxTotalDIPA" class="custom-control-label">
                                                Total DIPA</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxDIPA" value="optionDIPA"
                                                @click="showColumnDIPA = !showColumnDIPA">
                                            <label for="customCheckboxDIPA" class="custom-control-label">
                                                DIPA</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxCapaian" value="optionCapaian"
                                                @click="showColumnCapaian = !showColumnCapaian">
                                            <label for="customCheckboxCapaian" class="custom-control-label">
                                                Capaian</label>
                                        </div>
                                    </div>
                                    <div class="col-sm-2">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input custom-control-input-warning"
                                                type="checkbox" id="customCheckboxKeterangan" value="optionKeterangan"
                                                @click="showColumnKeterangan = !showColumnKeterangan">
                                            <label for="customCheckboxKeterangan" class="custom-control-label">
                                                Keterangan</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="table-responsive table-wrapper">
                        <table class="table m-0" id="tabeldata">
                            <thead>
                                <tr>
                                    <th style="width: 50px;" rowspan="2">No</th>
                                    <th style="width: 100px;" rowspan="2">PIU</th>
                                    <th style="width: 100px;" rowspan="2">Kegiatan</th>
                                    <th style="width: 100px;" rowspan="2" v-if="showColumnStatusKegiatan">
                                        Status<br>Kegiatan</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnOuput">Ouput
                                    </th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnPHOFHO">Status<br>PHO/FHO</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnPHOFHO">Tanggal<br>PHO/FHO</th>
                                    <th style="width: 50px;" rowspan="2">Target<br>Fisik (%)</th>
                                    <th style="width: 50px;" rowspan="2">Realisasi<br>Fisik (%)</th>
                                    <th style="width: 50px;" rowspan="2">Deviasi<br>Fisik (%)</th>
                                    <th style="width: 50px;" rowspan="2">
                                        Realisasi<br>Keuangan<br>Kumulatif<br>(Rp.)</th>
                                    <th style="width: 50px;" rowspan="2">Progres<br>Keuangan (%)</th>
                                    <th style="width: 50px;" rowspan="2">
                                        Status<br>Penyerapan<br>Anggaran</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnPenyedia">Penyedia</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnMulai">Mulai</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnSelesai">Selesai</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnDurasi">Durasi<br>(Bulan)</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnKontrak">Nomor Kontrak</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnAdendum">Adendum</th>
                                    <th style="width: 50px;" rowspan="2">Nilai Kontrak<br>(Rp.)</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnBerjalan">
                                        Waktu<br>Durasi<br>Berjalan<br>(%)</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnTersisa">
                                        Waktu<br>Durasi<br>Tersisa<br>(%)</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnOWP">OWP<br>(Rp.)</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnTotalAWP">Total<br>AWP<br>(Rp.)
                                    </th>
                                    <th style="width: 50px;" :colspan="colspan" v-if="showColumnAWP">AWP<br>Tahun (Rp.)
                                    </th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnTotalDIPA">
                                        Total<br>DIPA<br>(Rp.)</th>
                                    <th style="width: 50px;" :colspan="colspan" v-if="showColumnDIPA">DIPA<br>Tahun
                                        (Rp.)</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnCapaian">Capaian<br>(%)</th>
                                    <th style="width: 50px;" rowspan="2" v-if="showColumnKeterangan">Keterangan</th>
                                </tr>
                                <tr>
                                    <th v-if="showColumnAWP" v-for="(listtahun, uruttahun) in datatahun">{{ listtahun }}
                                    </th>
                                    <th v-if="showColumnDIPA" v-for="(listtahun, uruttahun) in datatahun">{{ listtahun
                                        }}</th>
                                </tr>
                            </thead>
                            <template v-for="(datalist, urutlist) in datamaster" :key="urutlist">
                                <tbody>
                                    <tr>
                                        <td class="text-center">{{ urutlist + 1 }}</td>
                                        <td>
                                            {{ datalist.nama_satker }}
                                        </td>
                                        <td>
                                            {{ datalist.Nama_Kegiatan }}
                                        </td>
                                        <td v-if="showColumnStatusKegiatan">
                                            {{ datalist.Status_pekerjaan }}
                                        </td>
                                        <td class="text-center" v-if="showColumnOuput">
                                            {{ datalist.Komponen }}
                                        </td>
                                        <td class="text-center" v-if="showColumnPHOFHO">
                                            {{ datalist.PHO_FHO }}
                                        </td>
                                        <td class="text-center" v-if="showColumnPHOFHO">
                                            {{ G_formatDateNonWIB(datalist.tanggalPHO_FHO) }}
                                        </td>
                                        <td class="text-center">
                                            {{ G_numKoma(datalist.TARGET) }}
                                        </td>
                                        <td class="text-center">
                                            {{ G_numKoma(datalist.PROGRES) }}
                                        </td>
                                        <td class="text-center">
                                            {{ G_numKoma(datalist.DEVIASI) }}
                                        </td>
                                        <td class="text-right">
                                            {{ G_numFormat(datalist.REALISASI_KUMULATIF) }}
                                        </td>
                                        <td class="text-center">
                                            {{ G_numKoma(datalist.PROGRESKEUANGAN) }}
                                        </td>
                                        <td class="text-center">
                                            {{ datalist.STATUS_KEU_PROYEK }}
                                        </td>
                                        <td class="text-justify" v-if="showColumnPenyedia">
                                            {{ datalist.KONTRAKTOR }}
                                        </td>
                                        <td class="text-center" v-if="showColumnMulai">
                                            {{ G_formatDateNonWIB(datalist.MULAI) }}
                                        </td>
                                        <td class="text-center" v-if="showColumnSelesai">
                                            {{ G_formatDateNonWIB(datalist.SELESAI) }}
                                        </td>
                                        <td class="text-center" v-if="showColumnDurasi">
                                            {{ G_numKoma(datalist.BULAN) }}
                                        </td>
                                        <td class="text-justify" v-if="showColumnKontrak">
                                            {{ datalist.NOKONTRAK }}
                                        </td>
                                        <td class="text-center" v-if="showColumnAdendum">
                                            {{ datalist.ADENDUM }}
                                        </td>
                                        <td class="text-right">
                                            {{ G_numFormat(datalist.NILAIKONTRAK) }}
                                        </td>
                                        <td class="text-center" v-if="showColumnBerjalan">
                                            {{ G_numKoma(datalist.DURASI) }}
                                        </td>
                                        <td class="text-center" v-if="showColumnTersisa">
                                            {{ G_numKoma(datalist.DURASITERSISA) }}
                                        </td>
                                        <td class="text-right" v-if="showColumnOWP">
                                            {{ G_numFormat(datalist.OWP) }}
                                        </td>
                                        <td class="text-right" v-if="showColumnTotalAWP">
                                            {{ G_numFormat(datalist.TOTALAWP) }}
                                        </td>
                                        <td class="text-right" v-if="showColumnAWP"
                                            v-for="(listawp, urutawp) in datalist.AWP" :key="urutawp">
                                            {{ G_numFormat(listawp.Nilai) }}
                                        </td>
                                        <td class="text-right" v-if="showColumnTotalDIPA">
                                            {{ G_numFormat(datalist.TOTALDIPA) }}
                                        </td>
                                        <td class="text-right" v-if="showColumnDIPA"
                                            v-for="(listdipa, urutdipa) in datalist.DIPA" :key="urutdipa">
                                            {{ G_numFormat(listdipa.Nilai) }}
                                        </td>
                                        <td class="text-center" v-if="showColumnCapaian">
                                            {{ G_numFormat(datalist.CAPAIAN) }}
                                        </td>
                                        <td class="text-center" v-if="showColumnKeterangan">
                                            {{ datalist.KETERANGAN }}
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                            <tbody v-if="(datapesan == 'data kosong')">
                                <tr>
                                    <td colspan="5">Data masih kosong</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row g-4 justify-content-center">
                <p>&nbsp;</p>
            </div>
        </div>
    </div>
    <div class="container-fluid blog py-2">&nbsp;</div>
    <!-- Contact End -->
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";

export default {
    components: {
        Top, Footer, swal, DonutsChartMonitoringProyek: VueApexCharts
        , DonutsChartMonitoringWaktuProyek: VueApexCharts, DonutsChartMonitoringPVProyek: VueApexCharts
        , LineChartMonitoringProyek: VueApexCharts
    },
    data() {
        return {
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            carikata: '',
            colspan: 0,
            datatahun: [],
            bahasa: localStorage.getItem("bahasasistem"),
            tanggalsinkron: new Date(),
            tanggaldatamonev: new Date(),
            showColumnStatusKegiatan: false,
            showColumnOuput: false,
            showColumnPHOFHO: false,
            showColumnPenyedia: false,
            showColumnMulai: false,
            showColumnSelesai: false,
            showColumnDurasi: false,
            showColumnKontrak: false,
            showColumnAdendum: false,
            showColumnBerjalan: false,
            showColumnTersisa: false,
            showColumnOWP: false,
            showColumnTotalAWP: false,
            showColumnAWP: false,
            showColumnTotalDIPA: false,
            showColumnDIPA: false,
            showColumnCapaian: false,
            showColumnKeterangan: false,
            project_id: process.env.VUE_APP_PROJECT_ID,
        };
    },
    methods: {
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationmonitoring-Monev?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.datamaster = [];
                    this.datakonten = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datapesan = Response.data.message;
                        this.colspan = 0;
                        this.datatahun = [];
                        this.colspan = Response.data.jumlahtahun;
                        this.datatahun = Response.data.content.data[0].Tahun;
                        this.tanggalsinkron = Response.data.content.data[0].TanggalSinkronisasi;
                        this.tanggaldatamonev = Response.data.content.data[0].TanggalDataMonev;
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data[0].Content;
                        this.halamanloading = false;
                    }
                    else {
                        this.datapesan = '';
                        this.tanggalsinkron = new Date();
                        this.tanggaldatamonev = new Date();
                        this.colspan = 0;
                        this.datatahun = [];
                        //alert(this.datapesan);
                        this.halamanloading = false;

                    }
                }
            ).catch(error => {
                this.datapesan = '';
                this.tanggalsinkron = new Date();
                this.tanggaldatamonev = new Date();
                this.colspan = 0;
                this.datatahun = [];
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style></style>